var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuportePremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-4818 -2882)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4818 2882)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4811 -2876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.727,13.612h-.41v-.474A9.483,9.483,0,1,1,15.274,22.6V24.5A11.378,11.378,0,1,0,3.42,13.138v.474H3.01l1.358,1.63Z",
    transform: "translate(-1.998 -1.759)",
    fill: "#43577a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.655,18.672H19.4V15.828H14.655Zm2.845-1.9h.948v.948H17.5Zm-1.9,0h.948v.948H15.6Z",
    transform: "translate(-4.224 -4.448)",
    fill: "#43577a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4,22.414v-1.9H14.655v.373l1.524,1.524Z",
    transform: "translate(-4.224 -5.345)",
    fill: "#43577a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.845,18.75V10.216a1.424,1.424,0,0,0-1.422-1.422h-5.69a1.424,1.424,0,0,0-1.422,1.422v8.542c.073.031.147.058.22.092l.728-.44V9.741H19.9V20.085A1.42,1.42,0,0,0,20.845,18.75Z",
    transform: "translate(-3.776 -3.103)",
    fill: "#43577a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4,11.138H14.655v2.845H19.4Zm-2.845,1.9H15.6v-.948h.948Zm1.9,0H17.5v-.948h.948Z",
    transform: "translate(-4.224 -3.552)",
    fill: "#43577a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.139,31.767l-3.346-2.007v1.059H16.414v1.9H27.793v1.059Z",
    transform: "translate(-4.56 -7.112)",
    fill: "#43577a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.086,25.63l-1.112-.273-.081-.254a5.216,5.216,0,0,0-.342-.819l-.123-.237.6-.983-1.486-1.486-.983.6-.236-.122A5.19,5.19,0,0,0,9.5,21.71l-.254-.081-.273-1.112h-2.1L6.6,21.629l-.254.081a5.265,5.265,0,0,0-.819.342l-.236.122-.983-.6L2.821,23.065l.6.983-.122.236a5.219,5.219,0,0,0-.342.819l-.081.254-1.112.274v2.1l1.112.273.081.254a5.189,5.189,0,0,0,.342.819l.122.236-.6.982,1.486,1.486.983-.6.236.122a5.2,5.2,0,0,0,.819.342l.254.081.273,1.112h2.1l.273-1.112.254-.081a5.265,5.265,0,0,0,.819-.342l.236-.122.983.6,1.126-1.126V29.7l-.235-.388.123-.237c.041-.08.075-.16.112-.24V28.1h.279l.031-.1,1.112-.273ZM7.922,30.948a4.267,4.267,0,1,1,4.267-4.267A4.272,4.272,0,0,1,7.922,30.948Z",
    transform: "translate(-1.759 -5.345)",
    fill: "#43577a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.595,24.034a3.319,3.319,0,1,0,3.319,3.319A3.323,3.323,0,0,0,8.595,24.034Zm0,5.69a2.371,2.371,0,1,1,2.371-2.371A2.373,2.373,0,0,1,8.595,29.724Z",
    transform: "translate(-2.431 -6.017)",
    fill: "#43577a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.422,
    cy: 1.422,
    r: 1.422,
    transform: "translate(4.741 19.914)",
    fill: "#43577a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuportePremium);
export default __webpack_public_path__ + "static/media/suporte_premium.3b44213f665696dbcb4ca3639834b34a.svg";
export { ForwardRef as ReactComponent };